import React from 'react';
import {ModalDangerButtons, Modal} from 'components/modals';
import {observer} from 'mobx-react';
import _ from 'lodash';
import {TextArea} from 'components';
import {FormattedMessage} from 'react-intl';

const PromptModal = ({isOpen, uiState}) => {
  const {editingPrompt, position} = uiState;

  return (
    <Modal
      size='md'
      title='recruiting.hiring_funnel.AI Screener'
      onHide={() => uiState.closePromptModal()}
      isOpen={isOpen}
    >
      <TextArea
        label='Prompt'
        value={editingPrompt.text}
        onChange={(e) => editingPrompt.merge({text: e.target.value})}
        placeholder='recruiting.hiring_funnel.Enter your prompt here'
        minRows={5}
      />
      <div className='waterloo'>
        <FormattedMessage id='recruiting.hiring_funnel.CANDIDATE_ESTIMATE' values={{count: position.activeCandidateCount}}/>
      </div>
      <ModalDangerButtons
        saveCaption='recruiting.hiring_funnel.Run Prompt'
        onCancel={() => uiState.closePromptModal()}
        onSave={() => uiState.runPrompt()}
      />
    </Modal>
  );
};

export default observer(PromptModal);
